import * as micLib from "microscope";
import { select, selectAll } from "d3-selection";

document.addEventListener("DOMContentLoaded", function(event) {
  // check if orgSeq mode
  const isOrgSeqMode = select("#headerselectseq").empty() ? false : true;
  const biobListId = "select-pkgdb-organism-selector";
  const headerOrgName = select("#headerorgname").style("margin-top", () =>
    isOrgSeqMode ? null : "10px"
  );
  const organismSelectorHtmlContainer = select("#headerchange").node();
  const singleOrganismSelector = micLib.organismSelector(
    false,
    [],
    "form-control-sm"
  );
  singleOrganismSelector(
    biobListId,
    12,
    500,
    organismSelectorHtmlContainer
  );

  singleOrganismSelector.onBiobListChange(function(state) {
    const [org, ...rest] = micLib.getInSelectionBiobs(state, biobListId);
    if (org) {
      const { id: oid } = org;
      const { origin, pathname } = window.location;
      const href = origin + pathname + "?O_id=" + oid;
      window.location.assign(href);
    }
  });
});
